import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { AccountCategory } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<AccountCategory.Basic>> =>
	Http.get(baseUrl, { params })
